import { FavoriteClusterComponent } from './../favorite-cluster/favorite-cluster.component';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { FavoriteCardTypeEnum, FavoriteProductEnum, UserFavoriteCardData, UserFavoriteTracker } from '../user-favorite-data.model';
import { Currency } from 'projects/common/model/landingModel';
import { FavoriteSocialService } from '../favorite-social.service';
import { FlightsService } from 'projects/common/services/flights.service';
import { UpaTarget } from 'projects/common/services/upa.service';

@Component({
  selector: 'user-favorite-card',
  template: `
    <div (click)="handleCardClick()" class="offer-card-clickeable {{cardType}} {{data.offer_card_type}}">
      <div [ngSwitch]="data.product" class="eva-3-card -eva-3-shadow-line">
        <flights-card
          *ngSwitchCase="'FLIGHT'"
          [data]="data"
          [moduleId]="moduleId"
          [moduleIndex]="moduleIndex"
          [currency]="currency"
          [locale]="locale"
          [flow]="flow"
          [showDeleteBtn]="showDeleteBtn"
          [showAlertBtn]="showAlertBtn"
          [cardType]="cardType"
          [position]="position"
          [nextFlow]="nextFlow"
          [uniqueId]="uniqueId"
          (onDeleteFavoriteClick)="deleteFavoriteHandler()"
        />

        <accomodations-card
          *ngSwitchCase="'ACCOMMODATION'"
          [data]="data"
          [moduleId]="moduleId"
          [moduleIndex]="moduleIndex"
          [currency]="currency"
          [locale]="locale"
          [flow]="flow"
          [showDeleteBtn]="showDeleteBtn"
          [cardType]="cardType"
          [position]="position"
          [uniqueId]="uniqueId"
          (onDeleteFavoriteClick)="deleteFavoriteHandler()"
        />

        <activities-card
          *ngSwitchCase="'ACTIVITY'"
          [data]="data"
          [moduleId]="moduleId"
          [moduleIndex]="moduleIndex"
          [currency]="currency"
          [locale]="locale"
          [flow]="flow"
          [showDeleteBtn]="showDeleteBtn"
          [cardType]="cardType"
          [position]="position"
          [uniqueId]="uniqueId"
          (onDeleteFavoriteClick)="deleteFavoriteHandler()"
        />

        <cars-card
          *ngSwitchCase="'CAR'"
          [data]="data"
          [moduleId]="moduleId"
          [moduleIndex]="moduleIndex"
          [currency]="currency"
          [locale]="locale"
          [flow]="flow"
          [showDeleteBtn]="showDeleteBtn"
          [cardType]="cardType"
          [position]="position"
          [uniqueId]="uniqueId"
          (onDeleteFavoriteClick)="deleteFavoriteHandler()"
        />

        <transfers-card
          *ngSwitchCase="'TRANSFER'"
          [data]="data"
          [moduleId]="moduleId"
          [moduleIndex]="moduleIndex"
          [currency]="currency"
          [locale]="locale"
          [flow]="flow"
          [showDeleteBtn]="showDeleteBtn"
          [cardType]="cardType"
          [position]="position"
          [uniqueId]="uniqueId"
          (onDeleteFavoriteClick)="deleteFavoriteHandler()"
        />

        <favorite-cta *ngSwitchCase="'FAVORITE_CTA'" [data]="data" (onClick)="handleClickCTA()" [cardType]="cardType"/>
      </div>
    </div>
  `,
  styleUrls: ['./user-favorite-card.component.scss'],
})
export class UserFavoriteCardComponent {
  @Input() data: UserFavoriteCardData;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() locale: string;
  @Input() flow: string;
  @Input() currency: Currency;
  @Input() isWhiteLabel: boolean;
  @Input() showDeleteBtn: boolean;
  @Input() showAlertBtn: boolean;
  @Input() cardType: FavoriteCardTypeEnum;
  @Input() position: number;
  @Input() nextFlow: string;
  @Input() uniqueId: string;
  @Input() target: UpaTarget;

  @Output() favoriteDeleted = new EventEmitter<string>();

  constructor(
    public mediaPictureService: MediaPictureService,
    private favoriteSocialService: FavoriteSocialService,
    private flightsService: FlightsService) { }

  deleteFavoriteHandler(): void {
    const idFavorite = this.data.id;
    this.favoriteDeleted.emit(idFavorite);
  }

  handleCardClick(): void {
    if ((this.nextFlow === "CHECKOUT" || this.nextFlow === "MODAL_SEARCH") && this.data.product === FavoriteProductEnum.FLIGHT) {
      this.flightsService.showDistributionPassengersModal(this.moduleId, this.moduleIndex, this.locale, this.data, this.nextFlow);
    } else {
      this.openDirectUrl();
    }

    this.favoriteSocialService.sendTracker(
      this.moduleId,
      this.uniqueId,
      this.moduleIndex,
      this.data.product,
      UserFavoriteTracker.OPEN,
      this.target
    );
  }

  private openDirectUrl(): void {
    const DEFAULT_ADULTS = '1';
    const DEFAULT_CHILDREN = '0';
    const DEFAULT_INFANTS = '0';

    let urlToOpen = this.data.link?.url || '';

    if (this.data.product === FavoriteProductEnum.FLIGHT && urlToOpen) {
      urlToOpen = urlToOpen
        .replace("{adults}", DEFAULT_ADULTS)
        .replace("{children}", DEFAULT_CHILDREN)
        .replace("{infants}", DEFAULT_INFANTS);
    }

    window.open(urlToOpen, '_blank');
  }

  handleClickCTA(): void {
    window.open(this.data.link.url, '_blank');

    this.favoriteSocialService.sendTracker(
      this.moduleId,
      this.uniqueId,
      this.moduleIndex,
      FavoriteClusterComponent.FAVORITE_CTA,
      UserFavoriteTracker.OPEN,
      this.target
    );
  }

  handleOfferClick(): void {
    this.favoriteSocialService.sendTracker(
      this.moduleId,
      this.uniqueId,
      this.moduleIndex,
      this.data.product,
      UserFavoriteTracker.OPEN,
      this.target
    );
  }
}
